import React, {Component, ReactNode} from 'react'
import {currentMedia, GridContainer, GridItem} from '../../styledComponents/ResponsiveConvenience'
import {Colors} from '../../styledComponents/Constants'
import styled from 'styled-components'
import {Box} from '@mui/material'

interface Props {
    label: string
    labelPosition: React.CSSProperties['alignSelf']
    required?: boolean
    isVertical?: boolean
    content: ReactNode
}

class ResidentLabeledContentComponent extends Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render(): ReactNode {
        return <GridContainer>
            <GridItem over={this.props.isVertical ? 12 : 3} alignSelf={this.props.labelPosition}>
                <LabelText required={this.props.required}>
                    {this.props.label}
                </LabelText>
                {(this.props.isVertical || currentMedia.lessThan('sp')) &&
                    <Box height={'10px'}/>}
            </GridItem>
            <GridItem over={this.props.isVertical ? 12 : 9}>
                {this.props.content}
            </GridItem>
        </GridContainer>
    }
}

export default ResidentLabeledContentComponent

const LabelText = styled.div<{ required?: boolean }>`
  color: ${Colors.AccentDark};

  ${props => props.required && `
    &:after {
      content: "必須";
      margin: 0 0 0 10px;
      padding: 3px;
      color: #fff;
      font-size: 75%;
      background-color: ${Colors.Alert};
      white-space: nowrap;
    }
  `};
`
